import Briefcase from '@public/icons/briefcase.svg';
import Czechia from '@public/icons/czechia.svg';
import DoubleChat from '@public/icons/double-chat.svg';
import Net from '@public/icons/net.svg';
import Whistle from '@public/icons/whistle.svg';
import {
  ArrowRightLeft,
  BookUser,
  ChartColumn,
  ChartPie,
  CircleArrowRight,
  Coins,
  Crown,
  FileBadge,
  FileUser,
  IdCard,
  Inbox,
  KeyRound,
  Landmark,
  Link,
  Scroll,
  ShieldCheck,
  Table,
  TreePalm,
  Trophy,
  User,
  Users,
} from 'lucide-react';

import { ModuleTag, type TPermissions } from '@/types';

import type { NavigationItemProps } from './navigation.interface';

export const navigationItems: NavigationItemProps<keyof TPermissions>[] = [
  {
    href: '/address-book',
    label: 'Adresář',
    icon: <BookUser />,
    moduleName: ModuleTag.DIRECTORY,
  },
  {
    href: '/api-key',
    label: 'API Klíče',
    icon: <KeyRound />,
    moduleName: ModuleTag.API_KEY,
  },
  {
    href: '/survey',
    label: 'Anketa',
    icon: <ChartColumn />,
    moduleName: ModuleTag.SURVEY,
  },
  {
    href: '/bank',
    label: 'Banka',
    icon: <Landmark />,
    moduleName: ModuleTag.BANK,
  },
  {
    href: '/beach',
    label: 'Beach',
    icon: <TreePalm />,
    moduleName: ModuleTag.BEACH,
    subItems: [
      {
        href: '/beach-referee',
        label: 'Beach rozhodčí',
        icon: <Whistle />,
        moduleName: ModuleTag.BEACH_REFEREE,
      },
      {
        href: '/beach-delegation',
        label: 'Beach delegáti',
        icon: <Briefcase />,
        moduleName: ModuleTag.BEACH_DELEGATION,
      },
      {
        href: '/beach-statistic',
        label: 'Beach statistika',
        icon: <TreePalm />,
        moduleName: ModuleTag.BEACH_STATS,
      },
    ],
  },
  {
    href: '/voting',
    label: 'Hlasování',
    icon: <ChartPie />,
    moduleName: ModuleTag.VOTING,
  },
  {
    href: '/communication/sms',
    activeHref: '/communication',
    label: 'Komunikace',
    icon: <DoubleChat />,
    moduleName: ModuleTag.COMMUNICATION,
  },
  {
    href: '/nsa',
    label: 'NSA',
    icon: <Czechia className="!size-7" />,
    moduleName: ModuleTag.NSA,
  },
  {
    href: '/clubs/favorite',
    activeHref: '/clubs',
    label: 'Oddíly',
    icon: <Users />,
    moduleName: ModuleTag.CLUBS,
  },
  {
    href: '/office',
    label: 'Podatelna',
    icon: <Inbox />,
  },
  {
    href: '/registration',
    label: 'Registrace',
    icon: <Table />,
    moduleName: ModuleTag.USER,
    subItems: [
      {
        href: '/membership-fees/persons',
        activeHref: '/membership-fees',
        label: 'Členské příspěvky',
        icon: <Coins />,
        moduleName: ModuleTag.MEMBERSHIP_FEES,
      },
      {
        href: '/players',
        activeHref: '/players',
        label: 'Hráči',
        icon: <Users />,
        moduleName: ModuleTag.PLAYER,
        view: 'LIST',
      },
      {
        href: '/famous-people',
        label: 'Osobnosti',
        icon: <Crown />,
        moduleName: ModuleTag.FAMOUS_PEOPLE,
      },
      {
        href: '/player-transfer/search',
        activeHref: '/player-transfer',
        label: 'Přestupy',
        icon: <CircleArrowRight />,
        moduleName: ModuleTag.TRANSFERS,
      },
      {
        href: '/transfers/home',
        activeHref: '/transfers',
        label: 'Transfery',
        icon: <ArrowRightLeft />,
        moduleName: ModuleTag.TRANSFERS,
      },
      {
        href: '/qualification/browse',
        activeHref: '/qualification',
        label: 'Kvalifikace',
        icon: <ShieldCheck />,
        moduleName: ModuleTag.QUALIFICATION,
      },
      {
        href: '/license/overview',
        activeHref: '/license',
        label: 'Licence',
        icon: <IdCard />,
        moduleName: ModuleTag.LICENSE,
      },
    ],
  },
  {
    href: '/referee/me/matches',
    activeHref: '/referee',
    label: 'Rozhodčí',
    icon: <Whistle />,
    moduleName: ModuleTag.REFEREE,
    subItems: [
      {
        href: '/lists',
        label: 'Listiny',
        icon: <Scroll />,
        moduleName: ModuleTag.LISTS,
        view: 'MY_LISTS',
      } as NavigationItemProps<ModuleTag.LISTS>,
      {
        href: '/delegates',
        label: 'Delegáti',
        icon: <Briefcase />,
        moduleName: ModuleTag.DELEGATES,
      },
    ],
  },
  {
    href: '/roster/my-rosters',
    activeHref: '/roster',
    label: 'Soupisky',
    icon: <FileUser />,
    moduleName: ModuleTag.ROSTER,
  },
  {
    href: '/super-roster',
    label: 'S-Soupisky',
    icon: <FileBadge />,
    moduleName: ModuleTag.SUPER_ROSTER,
  },
  {
    href: '/links',
    label: 'S-Linky',
    icon: <Link />,
    moduleName: ModuleTag.SUPER_LINKS,
  },
  {
    href: '/competitions/my-competitions',
    activeHref: '/competitions',
    label: 'Soutěže',
    icon: <Trophy />,
    moduleName: ModuleTag.COMPETITIONS,
  },
  {
    href: '/sports-field',
    label: 'Sportoviště',
    icon: <Net />,
    moduleName: ModuleTag.SPORTSFIELD,
  },
  {
    href: '/personal-settings/dashboard',
    activeHref: '/personal-settings',
    label: 'Uživatel',
    icon: <User />,
    moduleName: ModuleTag.PERSONAL_SETTINGS,
  },
] as NavigationItemProps<ModuleTag>[];
